module.exports = __webpack_public_path__ + "static/media/hockey-league-wild-match.b9a1061f.gif";